
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'portals-platform-reference-fe',
  currentProjectVersion: 'static-1.1464',
  depVersions: {
  "portals-platform-reference-fe": "static-1.1464",
  "portals-platform-bend-plugin": "static-1.23",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.501",
  "foundations-assets": "static-1.5222",
  "foundations-theming": "static-1.4812",
  "foundations-theming-base": "static-1.3797",
  "foundations-theming-specialty": "static-1.2528",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8369",
  "hub-http-shared-msw-handlers": "static-1.10670",
  "hubspot-dlb": "static-2.1905",
  "react-dlb": "static-1.89",
  "data-fetching-client": "static-1.9988",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8538",
  "hub-http": "static-1.6547",
  "HubStyleTokens": "static-2.11826",
  "I18n": "static-7.1679",
  "js-cookie": "static-1.18",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1495",
  "quartz-config": "static-1.1279",
  "quartz-core": "static-1.6720",
  "quartz-routing": "static-1.931",
  "quick-fetch": "static-1.4151",
  "react": "static-7.196",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-fkhalid-rhumb-remove-redundant-softnav.2",
  "rpc-client-utils": "static-1.5002",
  "ui-addon-react-router-dom": "static-1.9868",
  "UIComponents": "static-3.8772",
  "usage-tracker": "static-1.7648",
  "usage-tracker-anonymous": "static-1.6065",
  "usage-tracker-core": "static-1.7498",
  "apollo-stack-hubspot": "static-3.94",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4366",
  "immutable": "static-2.87",
  "metrics-js": "static-1.9963",
  "react-redux": "static-7.79",
  "redux": "static-4.80",
  "styled-components": "static-2.99",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3778",
  "quartz-webpack": "static-1.3725",
  "bend-plugin-quartz-routing": "static-1.579",
  "bender-build-tools": "static-1.3452",
  "webpack-env": "static-1.54",
  "bend-plugin-foundations-theming": "static-1.3295",
  "framer-motion": "static-1.79",
  "hs-story-utils": "static-1.9761",
  "react-utils": "static-2.5579",
  "StyleGuideUI": "static-3.507",
  "stylex": "static-1.41",
  "HeadJS": "static-2.803",
  "quartz": "static-1.7501",
  "hs-test-utils-bend-plugin": "static-1.3480",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "ts-schema": "static-1.4317",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.89",
  "bend-plugin-foundations-components": "static-1.4807",
  "floating-ui": "static-1.63",
  "react-aria": "static-1.72",
  "react-create-root-preference": "static-1.78",
  "react-select-plus": "static-1.113",
  "react-virtualized": "static-2.107",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2730",
  "ui-fonts": "static-1.1088",
  "ui-images": "static-2.1260",
  "hs-locale-management": "static-1.318",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.91",
  "ui-addon-i18n": "static-1.11482",
  "interframe": "static-3.5090",
  "usage-tracker-multi": "static-1.6062",
  "opentelemetry-fe-types": "static-1.112",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.887",
  "hubspotter-http": "static-1.4887",
  "icons": "static-2.692",
  "jasmine": "static-4.4648",
  "jasmine-runner": "static-1.6785",
  "mobile-manifest-mixins": "static-1.583",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.487",
  "quartz-auth": "static-1.1176",
  "quartz-head": "static-1.1166",
  "quartz-i18n": "static-1.1176",
  "quartz-test": "static-1.1176",
  "quartz-tracking": "static-1.880",
  "trellis-components": "static-1.2749",
  "usage-tracker-container": "static-1.7638",
  "csstype": "static-1.50",
  "web-vitals": "static-1.15",
  "bend-plugin-chirp-manifest": "static-1.412",
  "chirp-fetch": "static-1.2231",
  "cssUtils": "static-1.957",
  "HubStyle": "static-2.12133",
  "react-input-autosize": "static-2.17",
  "stylex-utils": "static-1.147",
  "trellis-theming": "static-1.1308",
  "foundations-components-test-utils": "static-1.6021",
  "SharedI18nStrings": "static-1.183",
  "usage-tracker-public": "static-1.7459",
  "opentelemetry-web": "static-1.15",
  "sassPrefix": "static-1.225",
  "beacon-keepalive-queue": "static-1.40",
  "hubspotter-http-shared-msw-handlers": "static-1.10668",
  "usage-tracker-session-replay": "static-1.5334",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "foundations-components-legacy": "static-1.1563",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "portals-platform-reference-fe": "/portals-platform-reference-fe/static-1.1464",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.23",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.501",
  "foundations-assets": "/foundations-assets/static-1.5222",
  "foundations-theming": "/foundations-theming/static-1.4812",
  "foundations-theming-base": "/foundations-theming-base/static-1.3797",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2528",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8369",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10670",
  "hubspot-dlb": "/hubspot-dlb/static-2.1905",
  "react-dlb": "/react-dlb/static-1.89",
  "data-fetching-client": "/data-fetching-client/static-1.9988",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8538",
  "hub-http": "/hub-http/static-1.6547",
  "HubStyleTokens": "/HubStyleTokens/static-2.11826",
  "I18n": "/I18n/static-7.1679",
  "js-cookie": "/js-cookie/static-1.18",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1495",
  "quartz-config": "/quartz-config/static-1.1279",
  "quartz-core": "/quartz-core/static-1.6720",
  "quartz-routing": "/quartz-routing/static-1.931",
  "quick-fetch": "/quick-fetch/static-1.4151",
  "react": "/react/static-7.196",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-rhumb-remove-redundant-softnav.2",
  "rpc-client-utils": "/rpc-client-utils/static-1.5002",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9868",
  "UIComponents": "/UIComponents/static-3.8772",
  "usage-tracker": "/usage-tracker/static-1.7648",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6065",
  "usage-tracker-core": "/usage-tracker-core/static-1.7498",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4366",
  "immutable": "/immutable/static-2.87",
  "metrics-js": "/metrics-js/static-1.9963",
  "react-redux": "/react-redux/static-7.79",
  "redux": "/redux/static-4.80",
  "styled-components": "/styled-components/static-2.99",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3778",
  "quartz-webpack": "/quartz-webpack/static-1.3725",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.579",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "webpack-env": "/webpack-env/static-1.54",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3295",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-story-utils": "/hs-story-utils/static-1.9761",
  "react-utils": "/react-utils/static-2.5579",
  "StyleGuideUI": "/StyleGuideUI/static-3.507",
  "stylex": "/stylex/static-1.41",
  "HeadJS": "/HeadJS/static-2.803",
  "quartz": "/quartz/static-1.7501",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3480",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "ts-schema": "/ts-schema/static-1.4317",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.89",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4807",
  "floating-ui": "/floating-ui/static-1.63",
  "react-aria": "/react-aria/static-1.72",
  "react-create-root-preference": "/react-create-root-preference/static-1.78",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-virtualized": "/react-virtualized/static-2.107",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2730",
  "ui-fonts": "/ui-fonts/static-1.1088",
  "ui-images": "/ui-images/static-2.1260",
  "hs-locale-management": "/hs-locale-management/static-1.318",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.91",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11482",
  "interframe": "/interframe/static-3.5090",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6062",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.112",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.887",
  "hubspotter-http": "/hubspotter-http/static-1.4887",
  "icons": "/icons/static-2.692",
  "jasmine": "/jasmine/static-4.4648",
  "jasmine-runner": "/jasmine-runner/static-1.6785",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.583",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.487",
  "quartz-auth": "/quartz-auth/static-1.1176",
  "quartz-head": "/quartz-head/static-1.1166",
  "quartz-i18n": "/quartz-i18n/static-1.1176",
  "quartz-test": "/quartz-test/static-1.1176",
  "quartz-tracking": "/quartz-tracking/static-1.880",
  "trellis-components": "/trellis-components/static-1.2749",
  "usage-tracker-container": "/usage-tracker-container/static-1.7638",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.15",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.412",
  "chirp-fetch": "/chirp-fetch/static-1.2231",
  "cssUtils": "/cssUtils/static-1.957",
  "HubStyle": "/HubStyle/static-2.12133",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "stylex-utils": "/stylex-utils/static-1.147",
  "trellis-theming": "/trellis-theming/static-1.1308",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6021",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "usage-tracker-public": "/usage-tracker-public/static-1.7459",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "sassPrefix": "/sassPrefix/static-1.225",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.40",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10668",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5334",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1563",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
